import { throwError } from '@/utils'
import http from './userRequest'
import { createServerName, getToken } from './utils'
import { $t } from '@/i18n/LocalContext'
import { isbind } from '.'
import { obj2string } from '@base/lang'

export function checkToken() {
  console.log('checkToken called')

  if (!getToken()) return Promise.reject()

  if (window.inSDK) return Promise.resolve()

  return http.request({
    url: `/user/token`,
    method: 'POST',
    data: {
      appId: window.appId,
    },
  })
}

let globalDefaultZone: Zone['zoneId']
export async function getDefaultZone(): Promise<Zone['zoneId']> {
  if (globalDefaultZone) {
    return globalDefaultZone
  }

  const area = window.queryObj.area
  if (area !== 'eur') {
    return area === 'sea' ? 3 : 5
  }

  let defaultZone: Zone['zoneId'] = 1
  try {
    const res = await http.request<Rsp<Zone[]>>({
      url: `/user/zone`,
      method: 'POST',
      data: {
        appId: window.appId,
      },
    })
    const rsp = res.data
    const list = rsp.rspdata
    if (rsp.rtncode === 'SUCCESS' && Array.isArray(list) && list.length > 0) {
      list.some((zone) => {
        if (zone.isDefault) {
          defaultZone = zone.zoneId
        }
        return zone.isDefault
      })
    }
  } catch (error) {
    throwError(error)
  }

  globalDefaultZone = defaultZone
  return globalDefaultZone
}
export const getDefaultZone$ = getDefaultZone()

export async function getRoleList(zoneId: Zone['zoneId'], userId: string) {
  let list: Role[] = []
  let err: Error | null = null
  try {
    const res = await http.post<Rsp<Role[]>>('/user/list', {
      appId: window.appId,
      userId,
      zoneId,
    })
    const rsp = res.data
    const rspdata = rsp.rspdata
    if (
      rsp.rtncode === 'SUCCESS' &&
      Array.isArray(rspdata) &&
      rspdata.length > 0
    ) {
      list = rspdata
        .map((item) => {
          item.serverName = createServerName(item.serverId)
          const zoneName =
            {
              1: `${$t('美洲')} `,
              2: `${$t('欧洲')} `,
            }[zoneId as Exclude<Role['zoneId'], 0 | 3 | 5>] || ''
          item.optionName = `${zoneName}${item.serverName} ${item.nickname}`
          item.zoneId = zoneId
          return item
        })
        .sort((a, b) => {
          if (a.level === b.level) return 0
          return a.level > b.level ? -1 : 1
        })
    }
  } catch (error) {
    list = []
    err = new Error(obj2string(error))
    throwError(error)
  }

  return [list, err] as const
}

export async function getBindedPlayer() {
  const zoneId = await getDefaultZone$
  const res = await isbind(zoneId)
  if (!res.zoneId) {
    res.zoneId = zoneId
  }
  return res
}
